<template>
	<div class="zjxNotice">
		<div class="zxj_notice">
			<!--<div class="zxj_notice__title">
				<p>关于转发表彰2020~2021年全国“安康杯”竞赛活动先进集体和优秀个人的决定的通知</p>
			</div>-->
			<!--<div class="zxj_notice__other">
				<span>文件文号：建协函（2022）59号</span>
				<span>点击量：8,588</span>
				<span>发布时间：2022-08-12</span>
				<span>分享到：+*x=</span>
			</div>-->
			<div class="zxj_notice__detail" v-html="content">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getSignalPage

	} from '../../api/moudles/home.js'

	export default {
		data() {
			return {
				column_code: 0,
				content: '',
				label: '',
			}
		},
		props: {},
		watch: {
			'$route': function() {
				// console.log('路由切换', this.$route.query.label)
				this.column_code = this.$route.query.key
				this.label = this.$route.query.label
				const name = localStorage.getItem('webName')
				document.title = name + '-' + this.label
				this.getNavList()
			}
		},
		created() {
			this.column_code = this.$route.query.key
			this.label = this.$route.query.label
			const name = localStorage.getItem('webName')
			document.title = name + '-' + this.label
			// console.log('初始化', this.label)
			this.getNavList()
		},
		methods: {
			async getNavList() {
				await getSignalPage({
					data: {
						column_code: this.column_code
					},
					success: (res) => {
						// console.log(res)
						this.content = res.data.content
					}
				})
			},
		}
	}
</script>

<style scoped>
	.zjxNotice {
		min-height: 710px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.zxj_notice {
		width: 1200px;
		margin-top: 19px;
		min-height: 810px;
		background-color: #fff;
		/* display: flex;
		align-items: center;
		justify-content: center; */
	}

	.zxj_notice__title {
		width: 90%;
		margin-left: 5%;
		height: 70px;
		font-size: 24px;
		font-weight: 600;
		text-align: center;
		line-height: 70px;
		border-bottom: 1px solid #f5f5f5;
	}

	.zxj_notice__other {
		height: 50px;
		line-height: 50px;
		width: 80%;
		margin-left: 10%;
		display: flex;
		justify-content: space-evenly;
	}

	.zxj_notice__other>span {
		font-size: 14px;
		color: #d3d3d3;
	}

	.zxj_notice__detail {
		margin-top: 20px;
		width: 90%;
		margin-left: 5%;
	}

	>>>.zxj_notice__detail>p {
		/* text-indent: 2em; */
		line-height: 30px;
		letter-spacing: 1px;
	}

	>>>.zxj_notice__detail>p>img,
	.zxj_notice__detail>img,
	.zxj_notice__detail>span>img {
		max-width: 100% !important;
	}

	>>>.zxj_notice__detail table {
		border: 1px solid #ccc;
	}

	>>>.zxj_notice__detail table th,
	>>>.zxj_notice__detail table td {
		border: 1px solid #ccc;
	}

	>>>.zxj_notice__detail table td {
		padding: 0px 5px;
	}

	.zjxPageFooter {
		position: fixed !important;
		bottom: 0 !important;
	}
</style>
